angular.module('unica_invitation_list.invitation_list_controllers', [])

.controller('InvitationListBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.parseInvitationListToTimestamp = function(invitationListData) {
		invitationListData.zm_expiration_date = moment( invitationListData.zm_expiration_date ).format('YYYY-MM-DD');
		invitationListData.zm_expiration_time = moment( invitationListData.zm_expiration_time ).format('HH:mm:ss');
		invitationListData.am_expiration_date = moment( invitationListData.am_expiration_date ).format('YYYY-MM-DD');
		invitationListData.am_expiration_time = moment( invitationListData.am_expiration_time ).format('HH:mm:ss');
		return invitationListData;
	};

});


